import logo from './logo.svg';
import './App.css';
import Footer from "./components/Footer";
import Login_form from "./forms/Login_form";
import Register_form from "./forms/Register_form";
import Home from './pages/Home';
import Listings from './pages/Listings';
import Agents from './pages/Agents';
import Agency from './pages/Agency';
import About from './pages/About';
import Contact from './pages/Contact';
import Login_page from './pages/Login_page';
import Add_property from './pages/Add_property';
import {BrowserRouter as Router, Switch, Route, Link, Redirect} from "react-router-dom";

function App() {
  return (
    <Router>
			        	{/*<!--Loader-->*/}
                {/*<div className="vfx-loader">
                  <div className="loader-wrapper">
                  	<div className="loader-content">
                  		<div className="loader-dot dot-1"></div>
                  		<div className="loader-dot dot-2"></div>
                  		<div className="loader-dot dot-3"></div>
                  		<div className="loader-dot dot-4"></div>
                  		<div className="loader-dot dot-5"></div>
                  		<div className="loader-dot dot-6"></div>
                  		<div className="loader-dot dot-7"></div>
                  		<div className="loader-dot dot-8"></div>
                  		<div className="loader-dot dot-center"></div>
                  	</div>
                  </div>
                </div>*/}
                {/*<!-- Loader end -->*/}

                
                {/*<!-- Wrapper -->*/}
                <div id="wrapper"> 
                  {/*<!-- Compare Property Widget -->*/}
                  <div className="utf-compare-slidebar-area">
                    <div className="utf-smt-trigger-item"></div>
                    <div className="utf-smt-content">
                      <h4>Compare Property
                        <span className="utf-smt-mobile-trigger-item"></span>
                      </h4>
                      <div className="utf-smt-property-item"> 
                        {/*<!-- Property -->*/}
                        <div className="utf-listing-item compact"> <a href="single-property-page-2.html" className="utf-smt-listing-img-container">
                          <div className="utf-remove-compare-item"><i className="icon-line-awesome-close"></i></div>
                          <div className="utf-listing-badges-item"><span className="for-sale">For Sale</span></div>
                          <div className="utf-listing-img-content-item"> <span className="utf-listing-compact-title-item">Renovated Luxury Apartment <i>$420,000</i></span> </div>
                          <img src="assets/images/listing-01.jpg" alt=""/> </a> 
                		</div>
                        {/*<!-- Property -->*/}
                        <div className="utf-listing-item compact"> <a href="single-property-page-2.html" className="utf-smt-listing-img-container">
                          <div className="utf-remove-compare-item"><i className="icon-line-awesome-close"></i></div>
                          <div className="utf-listing-badges-item"><span className="for-sale">For Sale</span></div>
                          <div className="utf-listing-img-content-item"> <span className="utf-listing-compact-title-item">Renovated Luxury Apartment <i>$420,000</i></span> </div>
                          <img src="assets/images/listing-02.jpg" alt=""/> </a> 
                		</div>        
                      </div>
                      <div className="utf-smt-buttons"><a href="compare-properties.html" className="button">Compare Property</a></div>
                    </div>
                  </div>
                  {/*<!-- Compare Property Widget / End -->*/} 
                  


                  {/*====== Content section =============*/}
                  <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/listings" component={Listings} />
                    <Route exact path="/agents" component={Agents} />
                    <Route exact path="/agency" component={Agency} />
                    <Route exact path="/about" component={About} />
                    <Route exact path="/contact" component={Contact} />
                    <Route exact path="/login" component={Login_page} />
                    <Route exact path="/add_property" component={Add_property} />
                  </Switch>
                  {/*====== Content section END=============*/}



                 {/*<!-- Footer -->*/}
                 <Footer/>
                  {/*<!-- Footer / End -->*/} 
                  
                  {/*<!-- Back To Top Button -->*/}
                  <div id="backtotop"><a href="#"></a></div>
                </div>
                
                {/*<!-- Sign In Popup -->*/}
                <div id="utf-signin-dialog-block" className="zoom-anim-dialog mfp-hide dialog-with-tabs"> 
                  <div className="utf-signin-form-part">
                    <ul className="utf-popup-tabs-nav-item">
                      <li><a href="#login">Log In</a></li>
                      <li><a href="#register">Register</a></li>
                    </ul>
                    <div className="utf-popup-container-part-tabs"> 
                      {/*<!-- Login -->*/}
                      <div className="utf-popup-tab-content-item" id="login"> 
                        <div className="utf-welcome-text-item">
                          <h3>Welcome Back Sign in to Continue</h3>
                          <span>Don't Have an Account? <a href="#" className="register-tab">Sign Up!</a></span> 
                		</div>

                          {/*<!-- Login Form-->*/}
                            <Login_form/>
                          {/*<!-- Login Form  END-->*/}


                      </div>
                      
                      {/*<!-- Register -->*/}
                      <div className="utf-popup-tab-content-item" id="register"> 
                        <div className="utf-welcome-text-item">
                          <h3>Create your Account!</h3>
                		  <span>Don't Have an Account? <a href="#" className="register-tab">Sign Up!</a></span> 
                        </div> 

                        {/*<!-- Register -->*/} 
                            <Register_form/>
                        {/*<!-- Register END-->*/}      


                      </div>
                    </div>
                  </div>
                </div>
                {/*<!-- Sign In Popup / End -->*/}


    </Router>
  );
}

export default App;
